import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/hondo")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Shade in Hondo, TX | Texas Made Shade",
      description: "Custom welded awnings, sail shades, patio & pergola covers, marine canvas and aluminum fabrication for Hondo & Medina County. Free quotes — +1 (830) 390-9588.",
      image: hero,
      socialTitle: "Custom Awnings & Shade — Hondo, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving Hondo and Medina County.",
      keywords: "awnings Hondo, awning company Hondo, custom awnings Hondo, sail shades Hondo, patio covers Hondo, pergola covers Hondo, metal awnings Hondo, canvas awnings Hondo, Texas Made Shade",
    }),
    scripts: cityHeadScripts("Hondo", "Medina County"),
  }),
  component: () => <CityHomePage city="Hondo" region="Medina County" />,
});
